import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "@/pages/LegalLayout";

export default function Terms() {
  const { t } = useTranslation();
  return (
    <LegalLayout titleKey="terms.title" updatedKey="terms.updated">
      <p>{t("terms.intro")}</p>
      {[1,2,3,4,5,6,7,8,9].map((i) => (
        <React.Fragment key={i}>
          <h2>{t(`terms.s${i}_t`)}</h2>
          <p>{t(`terms.s${i}_p`)}</p>
        </React.Fragment>
      ))}
    </LegalLayout>
  );
}
